import React from "react";
import "../styles.css";
import CardCount from "../../CardCount/CardCount";
import icons from "../../../constants/icons";
import { connect } from "react-redux";
import { numberWithCommas } from "../../../utils/formatCurrency";
import Daily from "./Daily";
import Weekly from "./Weekly";
import Monthly from "./Monthly";
import PerStatus from "./PerStatus";
import { fetchTransactionsReversalsSummary } from "../../../queries/reports/transactionsQuery";
import reportFilters from "../../../queries/reports/reportFilters";
import DateFilter from "../../Filters/DateFilter";
import TransactionStatus from "../../Filters/TransactionStatus";
import PaymentMode from "../../Filters/PaymentMode";
import TransactionSubType from "../../Filters/TransactionSubType";
import language from "../../../language";

class Analytics extends React.Component {
  state = {
    totalTransactions: 0,
    totalSuccessTransactions: 0,
    totalPendingTransactions: 0,
    totalFailedTransactions: 0,
    numberOfTransactions: 0,
    totalOther: 0,
    totalAccounts: 0,
  };

  state = {
    isLoading: false,
    data: {},
  };

  componentDidMount() {
    this.handleQueries();
  }

  componentDidUpdate(prevProps) {
    if (this.props.filters !== prevProps.filters) {
      this.handleQueries();
    }
  }

  handleQueries() {
    this.getTotalTransactions(true);
    this.getTotalPendingTransactions(true);
    this.getTotalSuccessTransactions(true);
    this.getTotalFailedTransactions(true);
  }

  getTotalTransactions = async (isLoadingTotalTransactions) => {
    const { defaultLanguage, filters } = this.props;
    let { totalTransactions = 0 } = this.state;
    try {
      this.setState({ isLoadingTotalTransactions });

      const responseData = await fetchTransactionsReversalsSummary(
        defaultLanguage,
        await reportFilters(filters)
      );

      for (let el of responseData.content) {
        totalTransactions += el.amount;
      }

      this.setState({
        isLoadingTotalTransactions: false,
        totalTransactions,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoadingTotalTransactions: false,
      });
    }
  };

  getTotalPendingTransactions = async (isLoadingTotalPendingTransactions) => {
    const { defaultLanguage, filters } = this.props;
    let { totalPendingTransactions = 0 } = this.state;
    try {
      this.setState({ isLoadingTotalPendingTransactions });

      const responseData = await fetchTransactionsReversalsSummary(
        defaultLanguage,
        {
          ...(await reportFilters(filters)),
          transactionResult: "PENDING",
        }
      );

      for (let el of responseData.content) {
        totalPendingTransactions += el.amount;
      }

      this.setState({
        isLoadingTotalPendingTransactions: false,
        totalPendingTransactions,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoadingTotalPendingTransactions: false,
      });
    }
  };

  getTotalSuccessTransactions = async (isLoadingTotalSuccessTransactions) => {
    const { defaultLanguage, filters } = this.props;
    let { totalSuccessTransactions = 0 } = this.state;
    try {
      this.setState({ isLoadingTotalSuccessTransactions });

      const responseData = await fetchTransactionsReversalsSummary(
        defaultLanguage,
        {
          ...(await reportFilters(filters)),
          transactionResult: "SUCCESS",
        }
      );

      for (let el of responseData.content) {
        totalSuccessTransactions += el.amount;
      }

      this.setState({
        isLoadingTotalSuccessTransactions: false,
        totalSuccessTransactions,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoadingTotalSuccessTransactions: false,
      });
    }
  };

  getTotalFailedTransactions = async (isLoadingTotalFailedTransactions) => {
    const { defaultLanguage, filters } = this.props;
    let { totalFailedTransactions = 0 } = this.state;
    try {
      this.setState({ isLoadingTotalFailedTransactions });

      const responseData = await fetchTransactionsReversalsSummary(
        defaultLanguage,
        {
          ...(await reportFilters(filters)),
          transactionResult: "FAILED",
        }
      );

      for (let el of responseData.content) {
        totalFailedTransactions += el.amount;
      }

      this.setState({
        isLoadingTotalFailedTransactions: false,
        totalFailedTransactions,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoadingTotalFailedTransactions: false,
      });
    }
  };
  render() {
    return (
      <div className="analytics-container">
        <div className="row">
          <div className="col-md-3">
            <CardCount
              isLoading={this.state.isLoadingTotalTransactions}
              count={numberWithCommas(this.state.totalTransactions)}
              subCount="KES"
              title="Total Transactions"
              color="#078ECE"
              icon={icons.bankAccount}
              onPress={() => (window.location.href = "/")}
            />
          </div>
          <div className="col-md-3">
            <CardCount
              isLoading={this.state.isLoading}
              count={numberWithCommas(this.state.totalPendingTransactions)}
              subCount="KES"
              title="Pending Transactions"
              color="#078ECE"
              icon={icons.pendingTransaction}
              onPress={() => (window.location.href = "/")}
            />
          </div>
          <div className="col-md-3">
            <CardCount
              count={numberWithCommas(this.state.totalSuccessTransactions)}
              subCount="KES"
              title="Successful Transactions"
              color="#FF6D00"
              icon={icons.successTransaction}
              isLoading={this.state.isLoading}
              onPress={() => (window.location.href = `/`)}
            />
          </div>
          <div className="col-md-3">
            <CardCount
              count={numberWithCommas(this.state.totalFailedTransactions)}
              subCount="KES"
              title="Failed Transactions"
              color="#008000"
              icon={icons.failedTransaction}
              isLoading={this.state.isLoading}
              onPress={() => (window.location.href = `/`)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Daily />
          </div>
          <div className="col-md-6">
            <Weekly />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Monthly />
          </div>
          <div className="col-md-6">
            <PerStatus />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Analytics);
